namespace TabAurous.Inventory {
    export namespace JobWorkRejectionItemsService {
        export const baseUrl = 'Inventory/JobWorkRejectionItems';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<RejectionItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Inventory/JobWorkRejectionItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JobWorkRejectionItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
